export const Manifesto = () => {
    return (
        <section
            id="manifesto"
            data-testid="manifesto-section"
            className="relative bg-paper py-28 md:py-40"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 grid grid-cols-12 gap-8">
                <div className="col-span-12 md:col-span-3 reveal">
                    <p className="text-xs uppercase tracking-[0.28em] text-terracotta">
                        — Our manifesto
                    </p>
                </div>
                <div className="col-span-12 md:col-span-9 reveal">
                    <h2 className="font-serif text-forest text-4xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight font-light">
                        Travel should leave a place <em className="italic text-terracotta">better</em>
                        {" "}than you found it.
                    </h2>
                    <div className="mt-12 grid md:grid-cols-3 gap-12 text-slatewarm text-base md:text-[17px] leading-relaxed">
                        <p data-testid="manifesto-p1" className="dropcap">
                            We believe in homestays over hotels — in the grandmother who keeps the
                            kitchen warm long after the last guest has eaten, and the cousin who
                            walks you to the river at dawn because you asked, once, two days ago.
                        </p>
                        <p data-testid="manifesto-p2">
                            We believe in local guides over outsiders. The teenager from Khonoma
                            who knows which fern to chew when you're tired. The boatman in Majuli
                            who has rebuilt his home five times because the river keeps moving.
                            They are the experts. We are not.
                        </p>
                        <p data-testid="manifesto-p3">
                            And we believe in slow travel — three valleys, well, instead of eight,
                            badly. The Northeast does not reward hurry. It opens slowly, like a
                            morning, and only to those who are willing to sit and wait for it.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
